import { useSelector } from 'react-redux';
import { cmsEnvironment } from '../selectors';
export default function useCMSEnvironment() {
    const selectedEnvironment = useSelector(cmsEnvironment);
    return selectedEnvironment || 'master';
}
